// TODO reevaluate if this is needed or if postapp model can be used here

// tslint:disable: completed-docs
import { LoanApplicationStage } from '@shared/model/ApiResponses/ConsumerPortal/consumer-information.model';
import { AppSummary, CollateralDetail } from 'src/postapp/models/application.model';

export interface DashBoardApplication {
  loanPurpose: string;
  loanType: string;
  term: string;
  appNumber: string;
  loanStatus: string;
  loanStage: string;
  requestedLoanAmount: string;
  dealerCode: string;
  amount: string;
  imageUrl: string;
  imageLabel: string;
  cardHeader: string;
  customLoanType?: string;
  collateralDetails?: CollateralDetail[];
  loanProductName?: string;
  estMonthlyPayment: string;
  loanDocumentId: string;
  isAccepted: boolean;
  borrowerId: string;
  applicationStage: LoanApplicationStage;
  sortDate: Date;
  tempAppNumber?: string;
  loanExpired: boolean;
  subjectPropertyAddress1: string;
  subjectPropertyAddress2: string;
  sourceLoanType: string;
  fundedAmount?: string;
  fundedRate?: string;
  fundedTerm?: string;
  monthlyFundedPayment?: string;
  summary?: AppSummary;
}

export interface OAOAppSummary {
  summary?: AppSummary;
  /** membership name */
  membershipName: string;
  /** membership Status */
  membershipStatus: string;
  /** status */
  status: string;
  /** membership Id */
  memberId: string;
  /** application Number */
  appNumber: string;
  /** application temp Loan Number */
  tempLoanNumber?: string;
  /** application submitted or not */
  isAppSubmitted: boolean;
  /** applicants */
  applicants?: Applicant[];
}

/** Dashboard model */
export class Dashboard {
  constructor() {
    this.apps = [];
    this.loans = [];
  }
  /** list of consumer loans */
  public loans: DashBoardApplication[];
  /** list of OAO APPS */
  public apps: OAOAppSummary[];
}

/** Applicant model */
export interface Applicant {
  /** firstName */
  firstName?: string;
  /** lastName */
  lastName?: string;
  /** middleName */
  middleName?: string;
  /** email */
  email?: string;
}
